export default __webpack_public_path__ + "static/5-c7fb4ca2199b8fe7fe02758b0f5ed53e.jpeg";